import { useQuery } from "@tanstack/react-query";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { fetchCategories } from "../../../services/catalog.api";
import FoodCategoryCard from "../cards/FoodCategoryCard";

const breakpoints = {
  1200: { slidesPerView: 8,   spaceBetween: 10 },
  992:  { slidesPerView: 7,   spaceBetween: 10 },
  768:  { slidesPerView: 6,   spaceBetween: 8  },
  576:  { slidesPerView: 4.5, spaceBetween: 8  },
  400:  { slidesPerView: 3.5, spaceBetween: 8  },
};

export default function CategorySection({ selectedCategoryId }) {
  const navigate = useNavigate();

  const { data, isPending, error } = useQuery({
    queryKey: ["categories"],
    queryFn: fetchCategories,
  });

  const handleCategoryClick = (id) => {
    navigate(selectedCategoryId === id ? "/all-food" : `/all-food?categoryId=${id}`);
  };

  if (error) { toast.error(error?.message); return null; }
  if (data?.length === 0 && !isPending) return null;

  return (
    <div style={{ marginTop: 14 }}>
      <Swiper
        breakpoints={breakpoints}
        spaceBetween={8}
        slidesPerView={2.8}
      >
        {isPending
          ? [1, 2, 3, 4, 5, 6].map(i => (
              <SwiperSlide key={i}>
                <Skeleton height={80} borderRadius={10} />
              </SwiperSlide>
            ))
          : data?.map(category => (
              <SwiperSlide key={category._id}>
                <FoodCategoryCard
                  label={category.name}
                  image={category.image}
                  isActive={selectedCategoryId === category._id}
                  onClick={() => handleCategoryClick(category._id)}
                />
              </SwiperSlide>
            ))}
      </Swiper>
    </div>
  );
}
